import { forwardRef, useState } from 'react';
import { Input, type InputProps } from '@heroui/react';
import { EyeIcon, EyeSlashIcon, LockClosedIcon } from '@/icons';

/**
 * Password input with a show/hide toggle and a lock affordance — extracts the
 * pattern repeated across login/reset/create flows. Forwards the ref so it works
 * with React Hook Form's register().
 */
export const PasswordInput = forwardRef<HTMLInputElement, InputProps>(function PasswordInput(props, ref) {
  const [show, setShow] = useState(false);
  return (
    <Input
      ref={ref}
      type={show ? 'text' : 'password'}
      variant="bordered"
      autoComplete="current-password"
      startContent={<LockClosedIcon className="h-4 w-4 text-fg-subtle" aria-hidden="true" />}
      endContent={
        <button type="button" onClick={() => setShow((s) => !s)} className="text-fg-subtle hover:text-fg" aria-label={show ? 'Hide password' : 'Show password'}>
          {show ? <EyeSlashIcon className="h-5 w-5" /> : <EyeIcon className="h-5 w-5" />}
        </button>
      }
      {...props}
    />
  );
});
